
export default {
  name: 'RandomGuidGenerator',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
        "@type": "Question",
        "name": "How Long Is A Random GUID?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "A random GUID is typically 128 bits long, equivalent to 32 hex characters, often displayed in the format \"550e8400-e29b-41d4-a716-446655440000.\""
        }
      },{
        "@type": "Question",
        "name": "What Is The Purpose Of Using A GUID Instead Of Other Unique IDs?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The purpose of using a GUID is to ensure global uniqueness. Unlike some unique IDs that might be based on predictable patterns or sequences, GUIDs are highly unlikely to collide. So, they are suitable for distributed systems and databases."
        }
      },{
        "@type": "Question",
        "name": "Where Are Random GUIDs Commonly Used?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Random GUIDs are commonly used in databases as primary keys, in distributed systems to track unique entities, in security protocols for generating secure tokens, and in various software development scenarios."
        }
      },{
        "@type": "Question",
        "name": "Is There A Standard Format For Random GUIDs?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, there is a standard format for random GUIDs. It consists of 32 hex characters divided into five groups with hyphens, conforming to the following pattern: \"8-4-4-4-12.\""
        }
      }]
    };
  },
  data () {
    return {
      data: '',
      form: this.$vform({
        numbers: 1
      })
    }
  },
  methods: {
    RandomGuidGenerator() {
        this.form.post(`/tool/random-guid-generator`, { progress: false }).then(res => {
          this.data = Object.values(res.data);
        }).catch(e => {
          console.log(e);
        });
    },
    formatGUIDs(data) {
      return data.flat().join('\n');
    },
    onSample(){
        this.form.numbers = 12;
    },
    onReset(){
        this.form.reset();
        this.data = '';
    },
    copyToClipboard() {
      document.getElementById("text").select();
      document.execCommand('copy');
    }
  }
}
